import Button from '@mui/material/Button';
import { navigate } from 'gatsby';
import * as React from 'react';

interface ButtonLearnMoreProps {
  link: string;
}
export default function ButtonLearnMore(props: ButtonLearnMoreProps) {
  return (
    <>
      <Button
        color='info'
        variant='outlined'
        style={{
          borderRadius: '0px',
          alignItems: 'center',
          justifyContent: 'center',
          whiteSpace: 'normal',
          wordBreak: 'break-all',
          display: 'flex',
          fontFamily: 'OCR A Std',
          fontSize: '1rem',
        }}
        sx={{ mr: 2 }}
        onClick={() => {
          navigate(props.link);
        }}
      >
        Learn More
      </Button>
    </>
  );
}
